import { Injectable, isDevMode } from '@angular/core';
import { EMPTY, Subject } from 'rxjs';
import { ReportsHelpbuttonDaoService } from 'src/app/dao/helpbutton-dao-services/reports-helpbutton-dao-service/reports-helpbutton-dao.service';
import { FormGroup } from '@angular/forms';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { UserService } from '../../user-service/user.service';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class ReportsHelpbuttonService {

  accessToken = 'HEL';
  filterAssistancesForm: FormGroup;
  showAdvanced: boolean;
  refreshAssistancesListListener = new Subject<any>();
  refreshFormattedAssistancesListListener = new Subject<any>();

  constructor(private reportsDaoService: ReportsHelpbuttonDaoService,
              private userStorageService: UserStorageService,
              private userService: UserService) { }

  public getAssistanceDetail(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.reportsDaoService.getAssistanceDetail(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public filterAssistanceList(centerInternalIdList, datetimeFrom, datetimeTo, evaluationList, statusList) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.reportsDaoService.filterAssistanceList(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), centerInternalIdList, datetimeFrom, datetimeTo, evaluationList, statusList).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public rememberForm(filterAssistancesForm, showAdvanced) {
    this.filterAssistancesForm = filterAssistancesForm;
    this.showAdvanced = showAdvanced;
  }

  public getRememberedForm() {
    return { form: this.filterAssistancesForm, showAdvanced: this.showAdvanced };
  }

  public refreshAssistancesList(assistances) {
    this.refreshAssistancesListListener.next(assistances);
  }

  public refreshAssistancesListListen() {
    return this.refreshAssistancesListListener.asObservable();
  }

  public refreshFormattedAssistancesList(formattedAssistances) {
    this.refreshFormattedAssistancesListListener.next(formattedAssistances);
  }

  public refreshFormattedAssistancesListListen() {
    return this.refreshFormattedAssistancesListListener.asObservable();
  }
}
